'use client';

import dynamic from 'next/dynamic';

// Dynamically import the navigation menu components to reduce initial JS bundle size
export const NavigationMenu = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.NavigationMenu),
  {
    ssr: false,
    loading: () => <div className="h-10 animate-pulse rounded-md bg-neutral-800 w-[300px]"></div>
  }
);

export const NavigationMenuList = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.NavigationMenuList),
  { ssr: false }
);

export const NavigationMenuItem = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.NavigationMenuItem),
  { ssr: false }
);

export const NavigationMenuTrigger = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.NavigationMenuTrigger),
  { ssr: false }
);

export const NavigationMenuContent = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.NavigationMenuContent),
  { ssr: false }
);

export const NavigationMenuLink = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.NavigationMenuLink),
  { ssr: false }
);

export const NavigationMenuIndicator = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.NavigationMenuIndicator),
  { ssr: false }
);

export const NavigationMenuViewport = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.NavigationMenuViewport),
  { ssr: false }
);

export const navigationMenuTriggerStyle = dynamic(
  () => import('@/components/ui/navigation-menu').then((mod) => mod.navigationMenuTriggerStyle),
  { ssr: false }
);
